import React, { useEffect, useState, useCallback, useMemo, Fragment } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, TabContent, TabPane, ListGroup, ListGroupItem } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
//redux
import { useSelector, useDispatch } from "react-redux";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";

//Import actions
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";
import { getMaritalTax, resetMaritalTaxState } from "../../../store/maritalTax/action";
import { getEmployeeTax, resetEmployeeTaxState } from "../../../store/employeeTax/action";
import { getAccAccount, resetAccAccountState } from "../../../store/accAccount/action";
import { resetAccSettingState, getAccSetting as onGetAccSettings, addNewAccSetting as onAddNewAccSetting, updateAccSetting as onUpdateAccSetting, deleteAccSetting as onDeleteAccSetting, getAccSettingLoading } from "../../../store/accSetting/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AccSetting = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [passedverticalSteps, setPassedverticalSteps] = useState([1]);
  const dispatch = useDispatch();

  const { accSettings, isAccSettingCreated, isAccSettingSuccess, loading, error, employeeTaxs, employeeTaxLoading, maritalTaxs, maritalTaxLoading, accAccounts, accAccountLoading, clients, clientLoading, companies, companyLoading } = useSelector((state) => ({
    accSettings: state.AccSetting.accSettings,
    isAccSettingCreated: state.AccSetting.isAccSettingCreated,
    isAccSettingSuccess: state.AccSetting.isAccSettingSuccess,
    loading: state.AccSetting.loading,
    maritalTaxs: state.MaritalTax.maritalTaxs,
    maritalTaxLoading: state.MaritalTax.loading,
    employeeTaxs: state.EmployeeTax.employeeTaxs,
    employeeTaxLoading: state.EmployeeTax.loading,
    error: state.AccSetting.error,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [accSetting, setAccSetting] = useState([]);
  const [accSettingList, setAccSettingList] = useState([]);
  const [statusActive, setStatusActive] = useState([]);
  const [proRate, setProRate] = useState([]);
  const [employeeTaxList, setEmployeeTaxList] = useState([]);
  const [maritalTaxList, setMaritalTaxList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [searchValueSecond, setSearchValueSecond] = useState([]);
  const [searchValueThird, setSearchValueThird] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [thrMultiplier, setThrMultiplier] = useState([]);
  const [kpiMultiplier, setKpiMultiplier] = useState([]);
  const [accountingList, setAccountingList] = useState([]);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const columnsSecond = useMemo(
    () => [
      {
        Header: "Taxable name",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "From",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div>
              <p className="fw-semibold mb-1">{parseInt(cellProps.row.original.range_from).toLocaleString(["ban", "id"])}</p>
            </div>
          );
        },
      },
      {
        Header: "To",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div>
              <p className="fw-semibold mb-1">{parseInt(cellProps.row.original.range_to).toLocaleString(["ban", "id"])}</p>
            </div>
          );
        },
      },
      {
        Header: "Percentage",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div>
              <p className="fw-semibold mb-1">{parseInt(cellProps.row.original.amount).toLocaleString(["ban", "id"])}</p>
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);

  const {
    getTableProps: getTablePropsSecond,
    getTableBodyProps: getTableBodyPropsSecond,
    headerGroups: headerGroupsSecond,
    page: pageSecond,
    prepareRow: prepareRowSecond,
    canPreviousPage: canPreviousPageSecond,
    canNextPage: canNextPageSecond,
    pageOptions: pageOptionsSecond,
    gotoPage: gotoPageSecond,
    nextPage: nextPageSecond,
    previousPage: previousPageSecond,
    setPageSize: setPageSizeSecond,
    preGlobalFilteredRows: preGlobalFilteredRowsSecond,
    setGlobalFilter: setGlobalFilterSecond,
    state: { pageIndex: pageIndexSecond, pageSize: pageSizeSecond },
  } = useTable(
    {
      columns: columnsSecond,
      data: employeeTaxList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const columnsThird = useMemo(
    () => [
      {
        Header: "Non-taxable Name",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Code",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div>
              <p className="fw-semibold mb-1">{cellProps.row.original.code}</p>
            </div>
          );
        },
      },
      {
        Header: "Gender",
        accessor: "gender",
        filterable: true,
      },
      {
        Header: "Amount",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div>
              <p className="fw-semibold mb-1">{parseInt(cellProps.row.original.amount).toLocaleString(["ban", "id"])}</p>
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);

  const {
    getTableProps: getTablePropsThird,
    getTableBodyProps: getTableBodyPropsThird,
    headerGroups: headerGroupsThird,
    page: pageThird,
    prepareRow: prepareRowThird,
    canPreviousPage: canPreviousPageThird,
    canNextPage: canNextPageThird,
    pageOptions: pageOptionsThird,
    gotoPage: gotoPageThird,
    nextPage: nextPageThird,
    previousPage: previousPageThird,
    setPageSize: setPageSizeThird,
    preGlobalFilteredRows: preGlobalFilteredRowsThird,
    setGlobalFilter: setGlobalFilterThird,
    state: { pageIndex: pageIndexThird, pageSize: pageSizeThird },
  } = useTable(
    {
      columns: columnsThird,
      data: maritalTaxList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable
      ? column.isSorted
        ? column.isSortedDesc
          ? " sorting_desc"
          : " sorting_asc"
        : " sort"
      : "";
  };

  const onChangeInSelectSecond = (event) => {
    setPageSizeSecond(Number(event.target.value));
  };

  const onChangeInInputSecond = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPageSecond(page);
  };

  const onChangeInSelectThird = (event) => {
    setPageSizeThird(Number(event.target.value));
  };

  const onChangeInInputThird = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPageThird(page);
  };

  const onChangeSecond = useAsyncDebounce((value) => {
    setGlobalFilterSecond(value || undefined);
  }, 200);

  const onChangeThird = useAsyncDebounce((value) => {
    setGlobalFilterThird(value || undefined);
  }, 200);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    }];

  const proRateData = [
    {
      options: [
        { label: "Based On Working Day", value: "Based On Working Day" },
        { label: "Based On Calendar Day", value: "Based On Calendar Day" },
        { label: "Custom On Working Day", value: "Custom On Working Day" },
        { label: "Custom On Calendar Day", value: "Custom On Calendar Day" },
      ],
    }];

  const InventoryData = [
    {
      options: [
        { label: "FIFO", value: "FIFO" },
        { label: "LIFO", value: "LIFO" },
        { label: "AVERAGE", value: "AVERAGE" },
      ],
    }];

  function toggleVerticalTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedverticalSteps, tab];
      setActiveTab(tab);
      setPassedverticalSteps(modifiedSteps);
    }
  }

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isSearch) {
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method && obj?.data?.user?.user_position?.position_role.method);
        setUserData(obj.data);
        setUserType(obj?.data?.userType);
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
        setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`)
        setClientSelect({
          label: obj.data.client_name,
          value: obj.data.clientId
        });
        setCompanySelect({
          label: obj.data.company_name,
          value: obj.data.companyId
        });
        setDefaultCompanyId(obj.data.companyId);

        dispatch(resetAccSettingState());
        dispatch(resetMaritalTaxState());
        dispatch(resetEmployeeTaxState());
        dispatch(getMaritalTax());
        dispatch(getEmployeeTax());
        dispatch(resetClientState());
        dispatch(getClient());
        handleGetCompany(obj.data.clientId);
        handleGetAccAccount(obj.data.companyId);
        dispatch(onGetAccSettings({ companyId: obj.data.companyId }));
      }
    }
  }, [dispatch, isSearch]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };
  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(accSettings)) {
      accSettings.company = accSettings.acc_setting_company && {
        label: accSettings.acc_setting_company.name,
        value: accSettings.acc_setting_company.id,
      };
      accSettings.client = accSettings.acc_setting_client && {
        label: accSettings.acc_setting_client.name,
        value: accSettings.acc_setting_client.id,
      };
      accSettings.accountSalesShipping = accSettings.acc_setting_sales_shipping_account && {
        label: accSettings.acc_setting_sales_shipping_account.name,
        value: accSettings.acc_setting_sales_shipping_account.id,
      };
      accSettings.accountSalesDiskon = accSettings.acc_setting_sales_discount_account && {
        label: accSettings.acc_setting_sales_discount_account.name,
        value: accSettings.acc_setting_sales_discount_account.id,
      };
      accSettings.accountPurchaseShipping = accSettings.acc_setting_purchase_shipping_account && {
        label: accSettings.acc_setting_purchase_shipping_account.name,
        value: accSettings.acc_setting_purchase_shipping_account.id,
      };
      accSettings.accountPurchaseDiskon = accSettings.acc_setting_purchase_discount_account && {
        label: accSettings.acc_setting_purchase_discount_account.name,
        value: accSettings.acc_setting_purchase_discount_account.id,
      };
      accSettings.accountBook = accSettings.acc_setting_book_account && {
        label: accSettings.acc_setting_book_account.name,
        value: accSettings.acc_setting_book_account.id,
      };
      accSettings.accountDownPayment = accSettings.acc_setting_down_payment_account && {
        label: accSettings.acc_setting_down_payment_account.name,
        value: accSettings.acc_setting_down_payment_account.id,
      };
      accSettings.accountDownPaymentRevenue = accSettings.acc_setting_down_payment_revenue_account && {
        label: accSettings.acc_setting_down_payment_revenue_account.name,
        value: accSettings.acc_setting_down_payment_revenue_account.id,
      };
      accSettings.accountDownPaymentExpense = accSettings.acc_setting_down_payment_expense_account && {
        label: accSettings.acc_setting_down_payment_expense_account.name,
        value: accSettings.acc_setting_down_payment_expense_account.id,
      };
      setAccSetting(accSettings);
      setProRate(accSettings.prorate_type);
      let thrSetting = [];
      if (accSettings.thr_multiplier_setting) {
        accSettings.thr_multiplier_setting.forEach((element) => {
          thrSetting.push({
            year: element.year,
            multiplier: element.multiplier,
          });
        });
        setThrMultiplier(thrSetting);
      }
      let kpiSetting = [];
      if (accSettings.kpi_multiplier_setting) {
        accSettings.kpi_multiplier_setting.forEach((element) => {
          kpiSetting.push({
            value: element.value,
            multiplier: element.multiplier,
          });
        });
        setKpiMultiplier(kpiSetting);
      }
    }
  }, [accSettings]);


  useEffect(() => {
    setAccSetting(accSettings);
  }, [accSettings]);

  useEffect(() => {
    if (!isEmpty(employeeTaxs)) {
      setEmployeeTaxList(employeeTaxs);
    }
  }, [employeeTaxs]);

  useEffect(() => {
    if (!isEmpty(maritalTaxs)) {
      setMaritalTaxList(maritalTaxs);
    }
  }, [maritalTaxs]);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      cutoff_at: (accSetting && accSetting.cutoff_at) || "25",
      prorate_type: accSetting && accSetting.prorate_type ? { label: accSetting.prorate_type, value: accSetting.prorate_type } : null,
      cogs: accSetting && accSetting.cogs ? { label: accSetting.cogs, value: accSetting.cogs } : null,
      prorate_amount: accSetting && accSetting.prorate_amount,
      thr_minimum_month: (accSetting && accSetting.thr_minimum_month) || "1",
      thr_rounded_day: (accSetting && accSetting.thr_rounded_day) || "15",
      kpi_minimum_month: (accSetting && accSetting.kpi_minimum_month) || "1",
      kpi_rounded_day: (accSetting && accSetting.kpi_rounded_day) || "15",
      absent_compensation: (accSetting && accSetting.absent_compensation) || "22",
      leaved_amount: (accSetting && accSetting.leaved_amount) || "12",
      client: (accSetting && accSetting.client) || clientSelected,
      company: (accSetting && accSetting.company) || companySelected,
      accountSalesShipping: (accSetting && accSetting.accountSalesShipping) ?? "",
      accountSalesDiskon: (accSetting && accSetting.accountSalesDiskon) ?? "",
      accountPurchaseShipping: (accSetting && accSetting.accountPurchaseShipping) ?? "",
      accountPurchaseDiskon: (accSetting && accSetting.accountPurchaseDiskon) ?? "",
      accountDownPayment: (accSetting && accSetting.accountDownPayment) ?? "",
      accountBook: (accSetting && accSetting.accountBook) ?? "",
      accountDownPaymentRevenue: (accSetting && accSetting.accountDownPaymentRevenue) ?? "",
      accountDownPaymentExpense: (accSetting && accSetting.accountDownPaymentExpense) ?? "",
    },
    validationSchema: Yup.object({
      cutoff_at: Yup.string().required("Please Enter Cut Off Schedule").nullable(true),
      prorate_type: Yup.object().required("Please Pick Pro Rate").nullable(true),
      thr_minimum_month: Yup.string().required("Please Enter THR Minimum Month").nullable(true),
      thr_rounded_day: Yup.string().required("Please Enter Rounded Day Number").nullable(true),
      kpi_minimum_month: Yup.string().required("Please Enter KPI Minimum Month").nullable(true),
      kpi_rounded_day: Yup.string().required("Please Enter Rounded Day Number").nullable(true),
      absent_compensation: Yup.string().required("Please Enter Absent Compensation").nullable(true),
      leaved_amount: Yup.string().required("Please Enter Leaved Amount").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getAccSettingLoading());
      const newAccSetting = {
        id: accSettings ? accSettings.id : 0,
        cogs: values.cogs.value,
        cutoff_at: values.cutoff_at,
        prorate_type: values.prorate_type.value,
        prorate_amount: values.prorate_amount,
        thr_minimum_month: values.thr_minimum_month,
        thr_rounded_day: values.thr_rounded_day,
        absent_compensation: values.absent_compensation,
        leaved_amount: values.leaved_amount,
        kpi_minimum_month: values.kpi_minimum_month,
        kpi_rounded_day: values.kpi_rounded_day,
        thr_multiplier_setting: thrMultiplier,
        kpi_multiplier_setting: kpiMultiplier,
        companyId: values.company.value,
        clientId: values.client.value,
        accSalesShippingId: values.accountSalesShipping.value,
        accSalesDiskonId: values.accountSalesDiskon.value,
        accPurchaseShippingId: values.accountPurchaseShipping.value,
        accPurchaseDiskonId: values.accountPurchaseDiskon.value,
        accBookId: values.accountBook.value,
        accDownPaymentId: values.accountDownPayment.value,
        accDownPaymentRevenueId: values.accountDownPaymentRevenue.value,
        accDownPaymentExpenseId: values.accountDownPaymentExpense.value,
      };
      dispatch(onUpdateAccSetting(newAccSetting));
    },
  });

  function handleThrMultiplierAdd() {
    let fc = [];
    if (thrMultiplier) {
      thrMultiplier.forEach((element) => {
        fc.push(element);
      });
    }
    fc.push({
      year: "1",
      multiplier: "1",
    });
    setThrMultiplier(fc);
  }

  function handleKpiMultiplierAdd() {
    let fc = [];
    if (kpiMultiplier) {
      kpiMultiplier.forEach((element) => {
        fc.push(element);
      });
    }
    fc.push({
      value: "1",
      multiplier: "1",
    });
    setKpiMultiplier(fc);
  }

  document.title = "Payroll Settings | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Payroll Setting" pageTitle="Keuangan" />
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}>
          <Row>
            <Col xl={12}>
              <Card>
                <CardHeader className="card-header">
                  <div className="d-flex align-items-center ">
                    <h5 className="card-title mb-0 flex-grow-1">
                      Financial Setting &nbsp;
                      {isLoading && (
                        <>
                          <Spinner color="primary" type="grow" size={"sm"}>
                            Loading...
                          </Spinner>
                          &nbsp;
                          <Spinner color="success" type="grow" size={"sm"}>
                            Loading...
                          </Spinner>
                          &nbsp;
                        </>
                      )}
                    </h5>
                    <div className="flex-shrink-0">
                      <button type="submit" className="btn btn-primary">
                        <span className="d-flex align-items-center">
                          <span className="flex-grow-1 me-2">
                            <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SAVE ALL SETTING
                          </span>
                          {loading && (
                            <Spinner size="sm" className="flex-shrink-0" role="status">
                              Loading...
                            </Spinner>
                          )}
                        </span>
                      </button>
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <div className="row">
                    <div className="mb-3 col-lg-3">
                      <Label htmlFor="client-field" className="form-label">
                        Grup Usaha&nbsp; {clientLoading && (
                          <Spinner color="primary" size="sm">
                            Loading...
                          </Spinner>
                        )}
                      </Label>
                      <Select
                        name="client"
                        value={validation.values.client}
                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                        placeholder="Pilih Grup Usaha"
                        onChange={(e) => {
                          setCompanyList([]);
                          validation.setFieldValue("client", e);
                          handleGetCompany(e.value);
                        }}
                        options={clientList}></Select>
                    </div>
                    <div className="mb-3 col-lg-3">
                      <Label htmlFor="company-field" className="form-label">
                        Perusahaan&nbsp; {companyLoading && (
                          <Spinner color="primary" size="sm">
                            Loading...
                          </Spinner>
                        )}
                      </Label>
                      <Select
                        name="company"
                        value={validation.values.company}
                        placeholder="Pilih Perusahaan"
                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                        onChange={(e) => {
                          validation.setFieldValue("company", e);
                        }}
                        options={companyList}></Select>
                    </div>

                    <div className={"mb-3 col-lg-3"}></div>
                    <div className={"mb-3 col-lg-3"}>
                      <label>Inventory Method</label>
                      <Select
                        name="cogs"
                        placeholder="Enter Method"
                        value={validation.values.cogs}
                        onChange={(e) => {
                          validation.setFieldValue("cogs", e);
                        }}
                        options={InventoryData}></Select>
                      {validation.touched.cogs && validation.errors.cogs ? (
                        <small className="text-danger" type="invalid">
                          {validation.errors.cogs}
                        </small>
                      ) : null}
                    </div>
                    <div className="col-lg-12 border-bottom mb-3 me-3 ms-3"></div>
                    <div className="mb-3 col-lg-3">
                      <label className="form-label" htmlFor="accountSalesShipping">Sales Shipping Cost Account</label>
                      <Select
                        name="accountSalesShipping"
                        value={validation.values.accountSalesShipping}
                        placeholder="Enter account"
                        onChange={(e) => {
                          validation.setFieldValue("accountSalesShipping", e);
                        }}
                        options={accountingList}></Select>
                      {validation.touched.accountSalesShipping && validation.errors.accountSalesShipping && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.accountSalesShipping}
                        </small>
                      )}
                    </div>
                    <div className="mb-3 col-lg-3">
                      <label className="form-label" htmlFor="accountSalesDiskon">Sales Diskon Account</label>
                      <Select
                        name="accountSalesDiskon"
                        value={validation.values.accountSalesDiskon}
                        placeholder="Enter account"
                        onChange={(e) => {
                          validation.setFieldValue("accountSalesDiskon", e);
                        }}
                        options={accountingList}></Select>
                      {validation.touched.accountSalesDiskon && validation.errors.accountSalesDiskon && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.accountSalesDiskon}
                        </small>
                      )}
                    </div>
                    <div className="mb-3 col-lg-3">
                      <label className="form-label" htmlFor="accountPurchaseShipping">Purchase Shipping Cost Account</label>
                      <Select
                        name="accountPurchaseShipping"
                        value={validation.values.accountPurchaseShipping}
                        placeholder="Enter account"
                        onChange={(e) => {
                          validation.setFieldValue("accountPurchaseShipping", e);
                        }}
                        options={accountingList}></Select>
                      {validation.touched.accountPurchaseShipping && validation.errors.accountPurchaseShipping && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.accountPurchaseShipping}
                        </small>
                      )}
                    </div>
                    <div className="mb-3 col-lg-3">
                      <label className="form-label" htmlFor="accountPurchaseDiskon">Purchase Diskon Account</label>
                      <Select
                        name="accountPurchaseDiskon"
                        value={validation.values.accountPurchaseDiskon}
                        placeholder="Enter account"
                        onChange={(e) => {
                          validation.setFieldValue("accountPurchaseDiskon", e);
                        }}
                        options={accountingList}></Select>
                      {validation.touched.accountPurchaseDiskon && validation.errors.accountPurchaseDiskon && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.accountPurchaseDiskon}
                        </small>
                      )}
                    </div>
                    <div className="mb-3 col-lg-3">
                      <label className="form-label" htmlFor="accountBook">Booking Account</label>
                      <Select
                        name="accountBook"
                        value={validation.values.accountBook}
                        placeholder="Enter account"
                        onChange={(e) => {
                          validation.setFieldValue("accountBook", e);
                        }}
                        options={accountingList}></Select>
                      {validation.touched.accountBook && validation.errors.accountBook && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.accountBook}
                        </small>
                      )}
                    </div>
                    <div className="mb-3 col-lg-3">
                      <label className="form-label" htmlFor="accountDownPayment">Down Payment Account</label>
                      <Select
                        name="accountDownPayment"
                        value={validation.values.accountDownPayment}
                        placeholder="Enter account"
                        onChange={(e) => {
                          validation.setFieldValue("accountDownPayment", e);
                        }}
                        options={accountingList}></Select>
                      {validation.touched.accountDownPayment && validation.errors.accountDownPayment && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.accountDownPayment}
                        </small>
                      )}
                    </div>
                    <div className="mb-3 col-lg-3">
                      <label className="form-label" htmlFor="accountDownPaymentRevenue">Down Payment Revenue Account</label>
                      <Select
                        name="accountDownPaymentRevenue"
                        value={validation.values.accountDownPaymentRevenue}
                        placeholder="Enter account"
                        onChange={(e) => {
                          validation.setFieldValue("accountDownPaymentRevenue", e);
                        }}
                        options={accountingList}></Select>
                      {validation.touched.accountDownPaymentRevenue && validation.errors.accountDownPaymentRevenue && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.accountDownPaymentRevenue}
                        </small>
                      )}
                    </div>
                    <div className="mb-3 col-lg-3">
                      <label className="form-label" htmlFor="accountDownPaymentExpense">Down Payment Expense Account</label>
                      <Select
                        name="accountDownPaymentExpense"
                        value={validation.values.accountDownPaymentExpense}
                        placeholder="Enter account"
                        onChange={(e) => {
                          validation.setFieldValue("accountDownPaymentExpense", e);
                        }}
                        options={accountingList}></Select>
                      {validation.touched.accountDownPaymentExpense && validation.errors.accountDownPaymentExpense && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.accountDownPaymentExpense}
                        </small>
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4}>
              <Card>
                <CardHeader className="card-header">
                  <h5 className="card-title mb-0  flex-grow-1">Payroll Setting</h5>
                </CardHeader>
                <CardBody>
                  <div className="row">
                    <div className="mb-3 col-lg-6">
                      <label>Cut Off</label>
                      <Input name="cutoff_at" id="cutoff_at-field" className="form-control" placeholder="Enter Cut Off date" type="number" onChange={validation.handleChange} onBlur={validation.handleBlur} onFocus={e => e.target.select()} value={validation.values.cutoff_at} defaultValue={accSettings === null ? "" : accSettings.cutoff_at} invalid={validation.touched.cutoff_at && validation.errors.cutoff_at ? true : false} />
                      {validation.touched.cutoff_at && validation.errors.cutoff_at ? <FormFeedback type="invalid">{validation.errors.cutoff_at}</FormFeedback> : null}
                    </div>
                    <div className="mb-3 col-lg-6">
                      <label>Leaved Amount</label>
                      <Input name="leaved_amount" id="leaved_amount-field" className="form-control" placeholder="Enter Amount" type="number" onFocus={e => e.target.select()} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.leaved_amount} />
                    </div>
                    <div className={"mb-3"}>
                      <label>Pro Rate</label>
                      <Select
                        name="prorate_type"
                        placeholder="Enter Pro Rate"
                        value={validation.values.prorate_type}
                        onChange={(e) => {
                          validation.setFieldValue("prorate_type", e);
                          validation.setFieldValue("prorate_amount", null);
                          setProRate(e.value);
                        }}
                        options={proRateData}></Select>
                      {validation.touched.prorate_type && validation.errors.prorate_type ? (
                        <small className="text-danger" type="invalid">
                          {validation.errors.prorate_type}
                        </small>
                      ) : null}
                    </div>
                    {(proRate === "Custom On Working Day" || proRate === "Custom On Calendar Day") && (
                      <div className="mb-3 col-lg-3">
                        <label>Amount</label>
                        <Input name="prorate_amount" id="prorate_amount-field" className="form-control" placeholder="Enter Amount" type="number" onFocus={e => e.target.select()} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.prorate_amount} />
                      </div>
                    )}
                    {proRate === "Based On Working Day" && (
                      <div className="mb-3">
                        <small>(Work day from join date/Work day in period) * Basic salary</small>
                      </div>
                    )}
                    {proRate === "Based On Calendar Day" && (
                      <div className="mb-3">
                        <small>(Join date/Payroll period) * Basic salary</small>
                      </div>
                    )}
                    {proRate === "Custom On Working Day" && (
                      <div className="mb-3">
                        <small>(Work day from join date/Custom amount) * Basic salary</small>
                      </div>
                    )}
                    {proRate === "Custom On Calendar Day" && (
                      <div className="mb-3">
                        <small>(Join date/Custom amount) * Basic salary</small>
                      </div>
                    )}
                    <div className="mb-3 col-lg-6">
                      <label>Absent Compensation</label>
                      <Input name="absent_compensation" id="absent_compensation-field" className="form-control" placeholder="Enter Amount" type="number" onFocus={e => e.target.select()} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.absent_compensation} />
                    </div>
                    <div className="mb-3 col-lg-6">
                      <label>&nbsp;</label>
                      <div>
                        <small>Amount/Payrate</small>
                      </div>
                    </div>

                  </div>
                </CardBody>
                <ListGroup className="list-group-fill-success list-group-flush">
                  <ListGroupItem
                    tag="a"
                    to="#"
                    className={activeTab === 1 ? "active list-group-item-actionattendance" : "list-group-item-actionattendance"}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      toggleVerticalTab(1);
                    }}>
                    <i className="ri-settings-3-line me-2"></i> Taxable Income
                  </ListGroupItem>
                  <ListGroupItem
                    tag="a"
                    to="#"
                    className={activeTab === 2 ? "active list-group-item-actionattendance" : "list-group-item-actionattendance"}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      toggleVerticalTab(2);
                    }}>
                    <i className="ri-settings-3-line me-2"></i> Non-taxable Income
                  </ListGroupItem>
                  <ListGroupItem
                    tag="a"
                    to="#"
                    className={activeTab === 3 ? "active list-group-item-actionattendance" : "list-group-item-actionattendance"}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      toggleVerticalTab(3);
                    }}>
                    <i className="ri-settings-3-line me-2"></i> THR Bonus Setting
                  </ListGroupItem>
                  <ListGroupItem
                    tag="a"
                    to="#"
                    className={activeTab === 4 ? "active list-group-item-actionattendance" : "list-group-item-actionattendance"}
                    onClick={() => {
                      toggleVerticalTab(4);
                    }}>
                    <i className="ri-settings-3-line me-2"></i> KPI Bonus Setting
                  </ListGroupItem>
                </ListGroup>
              </Card>
            </Col>
            <Col xl={8}>
              <Card>
                <CardBody>
                  <div>
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId={1}>
                        <div className="card-body">
                          <Row>
                            <CardBody className="border border-top-0 border-end-0 border-start-0">
                              <Row>
                                <Col sm={2}>
                                  <div className="me-2 mb-2">
                                    <select className="form-select" value={pageSizeSecond} onChange={onChangeInSelectSecond}>
                                      {[10, 50, 100, 250, 500].map((pageSizeSecond) => (
                                        <option key={pageSizeSecond} value={pageSizeSecond}>
                                          {pageSizeSecond}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </Col>
                                <Col sm={4}>
                                  <div className="search-box me-2 mb-2 d-inline-block col-12">
                                    <input
                                      onChange={(e) => {
                                        setSearchValueSecond(e.target.value);
                                        onChangeSecond(e.target.value);
                                      }}
                                      id="search-bar-0"
                                      type="text"
                                      className="form-control search"
                                      placeholder={`Search...`}
                                      value={searchValueSecond ?? ""} />
                                    <i className="bx bx-search-alt search-icon"></i>
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Row>
                          <div className="table-responsive table-card mb-1">
                            <Table hover {...getTablePropsSecond()} className="align-middle table-nowrap">
                              <thead className="table-light">
                                {headerGroupsSecond.map((headerGroup, index) => (
                                  <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                                    {headerGroup.headers.map((column, index) => (
                                      <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                        {column.render("Header")}
                                        {generateSortingIndicator(column)}
                                        {/* <Filter column={column} /> */}
                                      </th>
                                    ))}
                                  </tr>
                                ))}
                              </thead>

                              <tbody {...getTableBodyPropsSecond()}>
                                {pageSecond.map((row) => {
                                  prepareRowSecond(row);
                                  return (
                                    <Fragment key={row.getRowProps().key}>
                                      <tr>
                                        {row.cells.map((cell, index) => {
                                          return (
                                            <td {...cell.getCellProps()} key={index}>
                                              {cell.render("Cell")}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    </Fragment>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>
                          <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                            <Col className="col-md-auto">
                              <div className="d-flex gap-1">
                                <Button color="light" onClick={previousPageSecond} disabled={!canPreviousPageSecond}>
                                  {"<"}
                                </Button>
                              </div>
                            </Col>
                            <Col className="col-md-auto d-none d-md-block">
                              Page
                              <strong>
                                {pageIndexSecond + 1} of {pageOptionsSecond.length}      </strong>
                            </Col>
                            <Col className="col-md-auto">
                              <Input type="number" min={1} style={{ width: 70 }} max={pageOptionsSecond.length} defaultValue={pageIndexSecond + 1} onChange={onChangeInInputSecond} />
                            </Col>
                            <Col className="col-md-auto">
                              <div className="d-flex gap-1">
                                <Button className="btn btn-light" onClick={nextPageSecond} disabled={!canNextPageSecond}>
                                  {">"}
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </TabPane>
                      <TabPane tabId={2}>
                        <div className="card-body">
                          <Row>
                            <CardBody className="border border-top-0 border-end-0 border-start-0">
                              <Row>
                                <Col sm={2}>
                                  <div className="me-2 mb-2">
                                    <select className="form-select" value={pageSizeThird} onChange={onChangeInSelectThird}>
                                      {[10, 50, 100, 250, 500].map((pageSizeThird) => (
                                        <option key={pageSizeThird} value={pageSizeThird}>
                                          {pageSizeThird}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </Col>
                                <Col sm={4}>
                                  <div className="search-box me-2 mb-2 d-inline-block col-12">
                                    <input
                                      onChange={(e) => {
                                        setSearchValueThird(e.target.value);
                                        onChangeThird(e.target.value);
                                      }}
                                      id="search-bar-0"
                                      type="text"
                                      className="form-control search"
                                      placeholder={`Search...`}
                                      value={searchValueThird ?? ""} />
                                    <i className="bx bx-search-alt search-icon"></i>
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Row>
                          <div className="table-responsive table-card mb-1">
                            <Table hover {...getTablePropsThird()} className="align-middle table-nowrap">
                              <thead className="table-light">
                                {headerGroupsThird.map((headerGroup, index) => (
                                  <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                                    {headerGroup.headers.map((column, index) => (
                                      <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                        {column.render("Header")}
                                        {generateSortingIndicator(column)}
                                        {/* <Filter column={column} /> */}
                                      </th>
                                    ))}
                                  </tr>
                                ))}
                              </thead>

                              <tbody {...getTableBodyPropsThird()}>
                                {pageThird.map((row) => {
                                  prepareRowThird(row);
                                  return (
                                    <Fragment key={row.getRowProps().key}>
                                      <tr>
                                        {row.cells.map((cell, index) => {
                                          return (
                                            <td {...cell.getCellProps()} key={index}>
                                              {cell.render("Cell")}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    </Fragment>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>
                          <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                            <Col className="col-md-auto">
                              <div className="d-flex gap-1">
                                <Button color="light" onClick={previousPageThird} disabled={!canPreviousPageThird}>
                                  {"<"}
                                </Button>
                              </div>
                            </Col>
                            <Col className="col-md-auto d-none d-md-block">
                              Halaman {pageIndexThird + 1} dari {pageOptionsThird.length} 
                            </Col>
                            <Col className="col-md-auto">
                              <Input type="number" min={1} style={{ width: 70 }} max={pageOptionsThird.length} defaultValue={pageIndexThird + 1} onChange={onChangeInInputThird} />
                            </Col>
                            <Col className="col-md-auto">
                              <div className="d-flex gap-1">
                                <Button className="btn btn-light" onClick={nextPageThird} disabled={!canNextPageThird}>
                                  {">"}
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </TabPane>
                      <TabPane tabId={3}>
                        <div className="row align-items-center">
                          <div className="mb-3 col-lg-8">
                            <label>Minimum month from join date to get THR Bonus</label>
                          </div>
                          <div className="mb-3 col-lg-4">
                            <Input name="thr_minimum_month" id="thr_minimum_month-field" className="form-control" placeholder="Enter Minimum Month" type="number" onFocus={e => e.target.select()} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.thr_minimum_month} invalid={validation.touched.thr_minimum_month && validation.errors.thr_minimum_month ? true : false} />
                            {validation.touched.thr_minimum_month && validation.errors.thr_minimum_month ? <FormFeedback type="invalid">{validation.errors.thr_minimum_month}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 col-lg-8">
                            <label>Rounded working day to 1 month</label>
                          </div>
                          <div className="mb-3 col-lg-4">
                            <Input name="thr_rounded_day" id="thr_rounded_day-field" className="form-control" placeholder="Enter Day Number" type="number" onFocus={e => e.target.select()} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.thr_rounded_day} invalid={validation.touched.thr_rounded_day && validation.errors.thr_rounded_day ? true : false} />
                            {validation.touched.thr_rounded_day && validation.errors.thr_rounded_day ? <FormFeedback type="invalid">{validation.errors.thr_rounded_day}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="mb-3 position-relative">
                          <Label htmlFor="education" className="form-label">
                            THR Multiplier Setting  </Label>
                          <button
                            type="button"
                            className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                            onClick={() => {
                              handleThrMultiplierAdd();
                            }}>
                            <i className="ri-add-line label-icon align-middle fs-16 me-1"></i> Add
                          </button>
                        </div>
                        {thrMultiplier &&
                          thrMultiplier.map((o, i) => {
                            return (
                              <div key={i} className="border-bottom mb-3">
                                <div className="row">
                                  <div className="mb-3 col-lg-8">
                                    <label>Year(s) of employee who have joined</label>
                                  </div>
                                  <div className="mb-3 col-lg-4">
                                    <Input
                                      name={`thr_multiplier_setting.${i}.year`}
                                      className="form-control"
                                      placeholder="Year join"
                                      type="number"
                                      onFocus={e => e.target.select()}
                                      value={thrMultiplier[i].year}
                                      onChange={(e) => {
                                        validation.setFieldValue(`thr_multiplier_setting.${i}.year`, e.target.value);
                                        thrMultiplier[i].year = e.target.value;
                                        if (e.target.value === "" || e.target.value === "0") thrMultiplier.splice(o, 1);
                                      }}
                                      onBlur={validation.handleBlur} />
                                  </div>
                                  <div className="mb-3 col-lg-8">
                                    <label>Multiplied By</label>
                                  </div>
                                  <div className="mb-3 col-lg-4">
                                    <Input
                                      name={`thr_multiplier_setting.${i}.multiplier`}
                                      className="form-control"
                                      placeholder="Multiplier"
                                      type="number"
                                      onFocus={e => e.target.select()}
                                      value={thrMultiplier[i].multiplier}
                                      onChange={(e) => {
                                        validation.setFieldValue(`thr_multiplier_setting.${i}.multiplier`, e.target.value);
                                        thrMultiplier[i].multiplier = e.target.value;
                                        if (e.target.value === "" || e.target.value === "0") thrMultiplier.splice(o, 1);
                                      }}
                                      onBlur={validation.handleBlur} />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </TabPane>
                      <TabPane tabId={4}>
                        <div className="row align-items-center">
                          <div className="mb-3 col-lg-8">
                            <label>Minimum month from join date to get kpi Bonus</label>
                          </div>
                          <div className="mb-3 col-lg-4">
                            <Input name="kpi_minimum_month" id="kpi_minimum_month-field" className="form-control" placeholder="Enter Minimum Month" type="number" onFocus={e => e.target.select()} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.kpi_minimum_month} invalid={validation.touched.kpi_minimum_month && validation.errors.kpi_minimum_month ? true : false} />
                            {validation.touched.kpi_minimum_month && validation.errors.kpi_minimum_month ? <FormFeedback type="invalid">{validation.errors.kpi_minimum_month}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 col-lg-8">
                            <label>Rounded working day to 1 month</label>
                          </div>
                          <div className="mb-3 col-lg-4">
                            <Input name="kpi_rounded_day" id="kpi_rounded_day-field" className="form-control" placeholder="Enter Day Number" type="number" onFocus={e => e.target.select()} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.kpi_rounded_day} invalid={validation.touched.kpi_rounded_day && validation.errors.kpi_rounded_day ? true : false} />
                            {validation.touched.kpi_rounded_day && validation.errors.kpi_rounded_day ? <FormFeedback type="invalid">{validation.errors.kpi_rounded_day}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="mb-3 position-relative">
                          <Label className="form-label">KPI Multiplier Setting </Label>
                          <button
                            type="button"
                            className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                            onClick={() => {
                              handleKpiMultiplierAdd();
                            }}>
                            <i className="ri-add-line label-icon align-middle fs-16 me-1"></i> Add
                          </button>
                        </div>
                        {kpiMultiplier &&
                          kpiMultiplier.map((o, i) => {
                            return (
                              <div key={i} className="border-bottom mb-3">
                                <div className="row">
                                  <div className="mb-3 col-lg-8">
                                    <label>KPI Value</label>
                                  </div>
                                  <div className="mb-3 col-lg-4">
                                    <Input
                                      name={`kpi_multiplier_setting.${i}.value`}
                                      className="form-control"
                                      placeholder="Year join"
                                      type="number"
                                      onFocus={e => e.target.select()}
                                      value={kpiMultiplier[i].value}
                                      onChange={(e) => {
                                        validation.setFieldValue(`kpi_multiplier_setting.${i}.value`, e.target.value);
                                        kpiMultiplier[i].value = e.target.value;
                                        if (e.target.value === "" || e.target.value === "0") kpiMultiplier.splice(o, 1);
                                      }}
                                      onBlur={validation.handleBlur} />
                                  </div>
                                  <div className="mb-3 col-lg-8">
                                    <label>Multiplied By</label>
                                  </div>
                                  <div className="mb-3 col-lg-4">
                                    <Input
                                      name={`kpi_multiplier_setting.${i}.multiplier`}
                                      className="form-control"
                                      placeholder="Multiplier"
                                      type="number"
                                      onFocus={e => e.target.select()}
                                      value={kpiMultiplier[i].multiplier}
                                      onChange={(e) => {
                                        validation.setFieldValue(`kpi_multiplier_setting.${i}.multiplier`, e.target.value);
                                        kpiMultiplier[i].multiplier = e.target.value;
                                        if (e.target.value === "" || e.target.value === "0") kpiMultiplier.splice(o, 1);
                                      }}
                                      onBlur={validation.handleBlur} />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </TabPane>
                    </TabContent>
                  </div>
                </CardBody>
                
              </Card>
            </Col>
          </Row>
        </Form>
      </Container>
    </div >
  );
};

export default AccSetting;
